import { getLocale } from '@/core/settings/utils';

export const formatOrdinalsDate = (n: number) => {
  const locale = getLocale();

  switch (locale) {
    case 'en-GB': {
      const pr = new Intl.PluralRules('en-US', { type: 'ordinal' });

      const suffixes = new Map([
        ['one', 'st'],
        ['two', 'nd'],
        ['few', 'rd'],
        ['other', 'th'],
      ]);

      const rule = pr.select(n);
      const suffix = suffixes.get(rule);
      return `${n}${suffix}`;
    }
    case 'de-DE':
      return `${n}.`;
    default:
      return `${n}`;
  }
};
